// src/components/layout/Footer/SocialLinks.tsx
import React from 'react';
import { Box, IconButton } from '@mui/material';
import { LinkedIn, Instagram, Facebook } from '@mui/icons-material';

// Direct color constants
const ICON_COLORS = {
  text: '#FFFFFF',
  border: 'rgba(255, 255, 255, 0.3)',
  hoverBg: 'rgba(255, 255, 255, 0.1)',
  hoverBorder: 'rgba(255, 255, 255, 0.5)',
} as const;

const socialLinks = [
  { Icon: LinkedIn, href: 'https://www.linkedin.com/company/skyporter/', label: 'LinkedIn' },
  { Icon: Instagram, href: 'https://www.instagram.com/skyporter_us/', label: 'Instagram' },
  { Icon: Facebook, href: 'https://www.facebook.com/people/SkyPorter/61576402461429/', label: 'Facebook' },
];

export const SocialLinks: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
      }}
    >
      {socialLinks.map(({ Icon, href, label }) => (
        <IconButton
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          sx={{
            bgcolor: 'transparent',
            color: ICON_COLORS.text,
            width: 40,
            height: 40,
            border: `1px solid ${ICON_COLORS.border}`,
            borderRadius: 1,
            '&:hover': {
              bgcolor: ICON_COLORS.hoverBg,
              borderColor: ICON_COLORS.hoverBorder,
            },
          }}
        >
          <Icon sx={{ fontSize: 20 }} />
        </IconButton>
      ))}
    </Box>
  );
};